import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { productAdminService } from '../../services/api';
import Button from '../../components/Button';
import Card from '../../components/Card';
import Input from '../../components/Input';
import { MailIcon } from '../../components/Icons';
import authStyles from '../../layouts/AuthLayout/AuthLayout.module.css';
import styles from './ProductAdmin.module.css';

export default function ProductAdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true); setError('');
    try {
      const response = await productAdminService.login(form);
      localStorage.setItem('productAdminToken', response.data.data.access_token);
      navigate('/product-admin/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid product-admin credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className={authStyles.container}>
      <div className={authStyles.content}>
        <Card className={authStyles.card}>
          <div className={authStyles.logo}>
            <img src="/image_1_3.png" alt="DSC Platform" className={authStyles.logoImage} />
          </div>
          <h1 className={styles.loginTitle}>Product Admin</h1>
          <p className={styles.loginSubtitle}>Securely manage companies, tokens, and signing activity from one place.</p>
          <form className={styles.loginForm} onSubmit={submit}>
            <Input label="Email" type="email" placeholder="Enter your email" value={form.email} required
              leftIcon={<MailIcon />} autoComplete="email"
              onChange={e => setForm({ ...form, email: e.target.value })} />
            <Input label="Password" type="password" placeholder="Enter your password" value={form.password} required
              autoComplete="current-password"
              onChange={e => setForm({ ...form, password: e.target.value })} />
            {error && <div className={styles.error}>{error}</div>}
            <Button type="submit" fullWidth loading={loading}>Sign in</Button>
          </form>
        </Card>
      </div>
      <div className={authStyles.footer}>
        <span>© 2026 DSC Platform. All rights reserved.</span>
      </div>
    </div>
  );
}
